import { makeStyles } from '@material-ui/core';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';

export type CashFinanceGroupClasses = 'container' | 'single' | 'multiFinance';

const cashFinanceGroupStyles = makeStyles<ISpcTheme, CashFinanceGroupClasses>(
  theme => ({
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
      },
    },
    single: {
      [theme.breakpoints.down('xs')]: {
        flex: 1.5,
      },
    },
    multiFinance: {
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'row',
        justifyContent: 'space-around',
        alignItems: 'flex-start',
      },
    },
  }),
  { name: 'Customise_CashFinanceGroup' },
);

export default cashFinanceGroupStyles;
